<template>
  <div class="order-summary">
    <h3 class="order-summary-title">Review order summary</h3>
    <div class="order-summary-container">
      <div class="order-summary-container-set">
        <div class="order-summary-container-set-img">
          <img :src="require(`@/assets/img/order-steps/frames/${defaults.style}-${defaults.view}.jpg`)" alt="design" />
        </div>
        <div class="order-summary-container-set-block">
          <div class="order-summary-container-set-block-item">
            <p class="order-summary-container-set-block-item-type">Set</p>
            <p class="order-summary-container-set-block-item-value">{{ tariffs[tariff] }}</p>
          </div>
          <div class="order-summary-container-set-block-item">
            <p class="order-summary-container-set-block-item-type">Style</p>
            <p class="order-summary-container-set-block-item-value">{{ INTERIOR_STYLES.find((item) => item.value === defaults.style).name }}</p>
          </div>
          <div class="order-summary-container-set-block-item">
            <p class="order-summary-container-set-block-item-type">Window view</p>
            <p class="order-summary-container-set-block-item-value">
              {{ WINDOW_VIEWS.find((item) => item.value === defaults.view).name }}
            </p>
          </div>
        </div>
      </div>
      <div class="order-summary-container-check">
        <div class="order-summary-container-check-price">
          <h4 class="order-summary-container-check-price-title">{{ calculatedPrice.count }} floor plans processing</h4>
          <div class="order-summary-container-check-price-description">
            <template v-for="(count, price) in calculatedPrice.items" :key="price">
              <p class="order-summary-container-check-price-description-item">${{ price.replace('.', ',') }} x {{ count }} item</p>
            </template>
          </div>
        </div>
        <div class="order-summary-container-check-total">
          <input v-model="promocode" placeholder="Enter discount code" class="order-summary-container-check-total-input" />
          <p v-if="errors.errorMessagePromo" class="order-summary-container-check-total-error">{{ errors.errorMessagePromo }}</p>
          <hr class="order-summary-container-check-total-line" />
          <div class="order-summary-container-check-total-price">
            <p class="order-summary-container-check-total-price-name">Order total</p>
            <p class="order-summary-container-check-total-price-value">{{ `$${calculatedPrice.sum}`.replace('.', ',') }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="order-summary-info">
      <div class="order-summary-info-email">
        <p class="order-summary-info-email-title">You will receive the result in 1 business day by email</p>
        <input v-model="email" class="order-summary-info-email-input" type="email" name="email" placeholder="E-mail" />
        <p v-if="tryNextStep && !email" class="order-summary-info-email-input-error">Please enter your email</p>
        <p v-if="errors.errorMessage" class="order-summary-info-email-input-error">{{ errors.errorMessage }}</p>
      </div>
      <div class="order-summary-info-type">
        <p class="order-summary-info-type-title">Introduce yourself:</p>
        <div class="order-summary-info-type-buttons">
          <div class="order-summary-info-type-buttons-item">
            <input id="company" type="radio" name="radio" value="company" v-model="customerType" checked />
            <label for="company">Company</label>
          </div>
          <div class="order-summary-info-type-buttons-item">
            <input id="personal" type="radio" name="radio" value="personal" v-model="customerType" />
            <label for="personal">Personal</label>
          </div>
        </div>
      </div>
    </div>
    <div class="order-modal-buttons">
      <button @click="openPrevStep" class="order-modal-button order-modal-button-second">Back</button>
      <button
        @click="next"
        :class="{
          'btn-summary-basic btn-form-payment-basic': tariff === 1,
          'btn-summary-plus btn-form-payment-plus': tariff === 2,
          'btn-summary-pro btn-form-payment-pro': tariff === 3,
          'btn-summary-render btn-form-payment-render': tariff === 4,
          'btn-summary-max btn-form-payment-max': tariff === 6,
        }"
        class="order-modal-button">
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
import { INTERIOR_STYLES, WINDOW_VIEWS } from '@/Components/En/Order/Steps/constants';

export default {
  name: 'OrderSummary',
  props: {
    calculatedPrice: {
      default: () => {},
      type: Object,
    },
    changePromocode: {
      default: () => {},
      type: Function,
    },
    defaults: {
      default: () => {},
      type: Object,
    },
    changeEmailAndType: {
      default: () => {},
      type: Function,
    },
    tariff: {
      default: 1,
      type: Number,
    },
    openNextStep: {
      default: () => null,
      type: Function,
    },
    openPrevStep: {
      default: () => null,
      type: Function,
    },
    makeOrder: {
      default: () => null,
      type: Function,
    },
    errors: {
      default: () => {},
      type: Object,
    },
    INTERIOR_STYLES: {
      default: INTERIOR_STYLES,
      type: Array,
    },
    WINDOW_VIEWS: {
      default: WINDOW_VIEWS,
      type: Array,
    },
  },

  data: () => ({
    tariffs: {
      1: 'Basic set',
      2: 'Plus set',
      3: 'Pro set',
      4: 'Render set',
      6: 'Max set',
    },
    email: null,
    customerType: 'company',
    promocode: null,
    tryNextStep: false,
    buttonText: 'Make payment',
  }),
  watch: {
    promocode() {
      this.changePromocode(this.promocode);
    },
    email() {
      this.changeEmailAndType(this.email, this.customerType);
    },
    customerType() {
      this.changeEmailAndType(this.email, this.customerType);
    },
  },
  mounted() {
    this.promocode = this.defaults.promocode;
    this.email = this.defaults.email;
    this.customerType = this.defaults.customerType;
  },
  methods: {
    next(e) {
      this.tryNextStep = true;
      if (!this.email) return;
      this.buttonText = 'Wait';
      this.makeOrder(e).finally(() => (this.buttonText = 'Make payment'));
    },
  },
};
</script>
